import { RedoFeaturedIcon } from "@redotech/arbiter/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";

interface MerchantOverrideItemRejectMessageProps {
  merchantCreatedPreRejectMessage: string;
}

export const MerchantOverrideItemRejectMessage = ({
  merchantCreatedPreRejectMessage,
}: MerchantOverrideItemRejectMessageProps) => {
  return (
    <Flex align="center" gap="xs">
      <RedoFeaturedIcon color="warning" Icon={AlertCircleIcon} size="xs" />
      <Text fontSize="xs" fontWeight="bold" textColor="disabled">
        {merchantCreatedPreRejectMessage}
      </Text>
    </Flex>
  );
};
